import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
export default class ReturnToUserButton extends Button {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", false);
  }
  view() {
    return m(Button, Object.assign({}, this.attrs, {
      icon: "fas fa-undo",
      loading: this.loading,
      onclick: this.returnToOriginalUser.bind(this)
    }), app.translator.trans('fof-impersonate.forum.return.button', {
      username: app.forum.attribute('fofImpersonateOriginalUsername')
    }));
  }
  returnToOriginalUser() {
    this.loading = true;
    m.redraw();
    app.request({
      method: 'POST',
      url: "".concat(app.forum.attribute('apiUrl'), "/impersonate/return")
    }).then(() => window.location.reload()).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
}
flarum.reg.add('fof-impersonate', 'forum/components/ReturnToUserButton', ReturnToUserButton);